import Body from "./Body";
import Header from "./Header";
import Footer from "./Footer";
import Meta from "./Meta";
import Column from "./Column";
import Row from "./Row";
import Cell from "./Cell";

export default class Builder {

    header(options) {
        options = options || {};
        return new Header(options);
    }

    body(options) {
        options = options || {};
        return new Body(options);
    }

    column(options) {
        options = options || {};
        return new Column(options);
    }

    row(options) {
        options = options || {};
        return new Row(options);
    }

    cell(options) {
        options = options || {};
        return new Cell(options);
    }

    footer(options) {
        options = options || {};
        return new Footer(options);
    }

    meta(options) {
        options = options || {};
        return new Meta(options);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Builder.js